import 'url-polyfill';
import imagesloaded from 'imagesloaded';

function handleCaption() {
    document.addEventListener('neosPhotoSwipe.open.after', () => {
        const instance = window.neosPhotoSwipe;

        if (!instance) {
            return;
        }

        // FIXME:
        // Flaky bugfix for a Firefox issue noticed in Firefox 70.0.1:
        // The image size calculation for automatically opened lightboxes
        // (when the item id is passed in the URI) is wrong.

        // The lines below seem to alleviate the issue, but should be removed if we can not reproduce
        // the problem anymore (including the ``imagesloaded`` dependency).
        imagesloaded(document.querySelector('.pswp__img'), () => {
            setTimeout(() => {
                instance.gallery.updateSize();
            }, 200);
        });

        attachClickEventListenerToShareButton();
        attachClickEventListenerToCopyLinkButton();

        instance.gallery.listen('afterChange', function() {
            attachClickEventListenerToShareButton();
            attachClickEventListenerToCopyLinkButton();
        });
    });

    function attachClickEventListenerToCopyLinkButton() {
        const captionButton = document.querySelector('.pswp__caption:not(.pswp__caption--fake) .js-gallery-copy-link');

        if (!captionButton) {
            return;
        }

        captionButton.addEventListener('click', event => {
            const newUri = generateUri(event.currentTarget.dataset.assetId);
            const button = event.currentTarget;

            copyStringToClipboard(newUri);
            button.innerHTML = 'kopiert';
        });
    }

    function attachClickEventListenerToShareButton() {
        const shareButton = document.querySelector(
            '.pswp__caption:not(.pswp__caption--fake) .js-gallery-facebook-share'
        );

        if (!shareButton) {
            return;
        }

        shareButton.addEventListener('click', () => {
            const uriToShare =
                'https://www.facebook.com/sharer.php?display=popup&u=' +
                encodeURIComponent(generateUri(event.currentTarget.dataset.assetId));
            const options = 'toolbar=0,status=0,resizable=1,width=626,height=436';

            window.open(uriToShare, 'Auf Facebook teilen', options);
        });
    }

    /**
     * Generate new Uri with asset id included within the query string.
     *
     * @param string assetId
     * @return string
     */
    function generateUri(assetId) {
        const newUrl = new URL(window.location);
        newUrl.searchParams.set('assetId', assetId);

        return newUrl.toString();
    }

    /**
     * Create invisible input field to copy string to clipboard.
     *
     * @param string link
     * @see: https://techoverflow.net/2018/03/30/copying-strings-to-the-clipboard-using-pure-javascript/
     */

    function copyStringToClipboard(link) {
        var el = document.createElement('textarea');
        el.value = link;
        el.setAttribute('readonly', '');
        el.style = { position: 'absolute', left: '-999999px' };
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
}

handleCaption();
